<div id="recaptcha-container"></div>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/shared/form/input-captcha/input-captcha.component.html